module.exports = __webpack_public_path__ + "static/media/gruende.998f75ed.png";